export const RETRY_LIMIT = 4;
export const RETRY_TIMEOUT = 1000 * 5; // 5 Seconds
